(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("bin-charts", [], factory);
	else if(typeof exports === 'object')
		exports["bin-charts"] = factory();
	else
		root["bin-charts"] = factory();
})(window, function() {
return 